export default {
  en: {
    copyright:
      'The final interpretation right of this event belongs to Yayya, and this event has nothing to do with Apple.',
    timeR: 'Count down ',
    timeR2: ' before the activity starts ',
    rank: 'Ranking',
    toptitle: 'Zafer Bayramı',
    title: 'Celebration KSA',
    ruleDes:
      'To celebrate KSA National Day, we will be holding events from September 23rd to 30th. During the event, users send the following gifts, and the winner can get rewards',
    nav1: 'Ranking',
    nav2: 'Room',
    nav3: 'Reward',
    rule: 'Rules',
    share: 'Share',
    rulePop:
      '1. All Turkish users can participate;<br/>2. Each time you give an event gift, you will receive the corresponding event gift currency;<br/>3. During the event, you will automatically enter the leaderboard according to the number of gifts given, and the top three will receive event-exclusive headwear, cars, and VIP rewards.<br/>4. The competition will end at 23:59 Saudi time on September 8, 2024;<br/>5. The final interpretation right of this event belongs to Yayya, and this event has nothing to do with Apple.',
    world: 'World',
    country: 'KSA',
    notice: 'If your account country is changed during the activity, your trophy ranking will be cleared.',
    days: 'days',
    eventGift: 'Event Gift',
    day: 'Day',
    hour: 'Hour',
    min: 'Min',
    sec: 'Sec'
  },
  ar: {
    copyright:
      'The final interpretation right of this event belongs to Yayya, and this event has nothing to do with Apple.',
    timeR: 'العد التنازلي ',
    timeR2: 'قبل بدء النشاط',
    rank: 'التصنيف',
    toptitle: 'Zafer Bayramı',
    title: 'إحتفال السعودية',
    ruleDes:
      'للاحتفال باليوم الوطني للمملكة العربية السعودية ، سنعقد فعاليات من 23 إلى 30 سبتمبر.  خلال الحدث ، يرسل المستخدمون الهدايا التالية ، ويمكن للفائز الحصول على مكافآت',
    nav1: 'التصنيف',
    nav2: 'الغرف',
    nav3: 'المكافآت',
    rule: 'القواعد',
    rulePop:
      '1. يمكن لجميع المستخدمين الأتراك المشاركة.<br/>2. في كل مرة تقدم فيها هدية حدث، ستتلقى عملة الحدث المقابلة.<br/>3. خلال الحدث، ستدخل تلقائيًا في لوحة الصدارة بناءً على عدد الهدايا التي تم تقديمها، وسيحصل الثلاثة الأوائل على إكسسوارات حصرية للحدث، سيارات، ومكافآت VIP.<br/>ستنتهي المسابقة في 8 سبتمبر 2024 في تمام الساعة 11:59 مساءً بتوقيت السعودية.<br/>5. الحق النهائي في تفسير هذا الحدث يعود إلى Yayya، وليس لهذا الحدث أي علاقة بشركة Apple.',
    world: 'العالم',
    country: 'KSA',
    notice: 'If your account country is changed during the activity, your trophy ranking will be cleared.',
    days: 'أيام',
    eventGift: 'هدية الحدث',
    day: 'Day',
    hour: 'Hour',
    min: 'Min',
    sec: 'Sec'
  },
  tr: {
    copyright: "Bu etkinliğin son yorumlama hakkı Yayya'ye ait olup, bu etkinliğin Apple ile hiçbir ilgisi yoktur.",
    timeR: 'Kalan Süre: ',
    timeR2: ' before the activity starts ',
    rank: 'Sıralama',
    toptitle: 'Zafer Bayramı',
    title: 'Kutlama Suudi Arabistan',
    ruleDes:
      "KSA Ulusal Günü'nü kutlamak için 23-30 Eylül tarihleri arasında etkinlikler düzenleyeceğiz. Etkinlik sırasında kullanıcılar aşağıdaki hediyeleri gönderir ve kazanan ödül alabilir",
    nav1: 'Sıralama',
    nav2: 'Oda',
    nav3: 'Ödül',
    rule: 'Kurallar',
    rulePop:
      "1. Yalnızca Türkiye, Azerbaycan ve Özbekistan paneli kullanıcıları katılabilir; <br/>2. Her etkinlik hediyesi gönderildiğinde, ilgili etkinlik hediyesi para birimini alacaksınız;<br/>3. Etkinlik sırasında, gönderilen hediye sayısına göre otomatik olarak skor tablosuna gireceksiniz ve ilk üçe, etkinliğe özel şapkalar, arabalar ve VIP ödülleri verilecek.<br/>4. Yarışma, 8 Eylül 2024 tarihinde Suudi Arabistan saatiyle 23:59'da sona erecektir;<br/>5. Bu etkinliğin son yorumlama hakkı Yayya'ye ait olup, bu etkinliğin Apple ile hiçbir ilgisi yoktur.",
    world: 'Dünya',
    country: 'KSA',
    notice: 'If your account country is changed during the activity, your trophy ranking will be cleared.',
    days: 'gün',
    eventGift: 'Etkinlik Hediyeleri',
    day: 'Gün',
    hour: 'Saat',
    min: 'Dakika',
    sec: 'Saniye'
  },
  uz: {
    copyright: 'Ushbu tadbirning yakuniy talqini Hobyga tegishli, va bu tadbir Apple bilan hech qanday aloqasi yo‘q.',
    timeR: 'Hisoblashni boshlash',
    timeR2: ' tadbir boshlanishidan oldin',
    rank: 'Reyting',
    toptitle: 'Zafer Bayramı',
    title: 'KSA bayrami',
    ruleDes:
      "KSA Milliy kunini nishonlash uchun biz 23-sentabrdan 30-sentabrgacha tadbirlar o'tkazamiz. Tadbir davomida foydalanuvchilar quyidagi sovg‘alarni jo‘natishadi, g‘olib esa mukofotlarni qo‘lga kiritadi.",
    nav1: 'Reyting',
    nav2: 'Xona',
    nav3: 'Mukofot',
    rule: 'Qoidalar',
    share: 'Ulashish',
    rulePop:
      '1. Barcha turkiyalik foydalanuvchilar qatnashishi mumkin;<br/>2. Har safar tadbir sovg‘asini bersangiz, tegishli tadbir valyutasini olasiz;<br/>3. Tadbir davomida berilgan sovg‘alar soniga qarab reytingga avtomatik kirishingiz mumkin, va eng yaxshi uchta ishtirokchi maxsus bosh kiyim, avtomobil va VIP mukofotlarni oladi.<br/>4. Musobaqa 2024-yil 8-sentabr, Saudiya vaqti bilan 23:59 da tugaydi;<br/>5. Ushbu tadbirning yakuniy talqini Hobyga tegishli, va bu tadbir Apple bilan hech qanday aloqasi yo‘q.',
    world: 'Dunyo',
    country: 'KSA',
    notice: 'Agar faoliyat davomida hisobingiz mamlakati o‘zgarsa, sizning kubok reytingingiz tozalanadi.',
    days: 'kunlar',
    eventGift: 'Tadbir sovg‘asi',
    day: 'Kun',
    hour: 'Soat',
    min: 'Daqiqa',
    sec: 'Soniya'
  },
  ru: {
    copyright: 'Окончательное право интерпретации этого события принадлежит Yayya, и это событие не связано с Apple.',
    timeR: 'Обратный отсчет',
    timeR2: ' до начала мероприятия',
    rank: 'Рейтинг',
    toptitle: 'Zafer Bayramı',
    title: 'Празднование KSA',
    ruleDes:
      'В честь Национального дня KSA с 23 по 30 сентября мы проводим мероприятия. В течение мероприятия пользователи отправляют следующие подарки, а победитель получает награды.',
    nav1: 'Рейтинг',
    nav2: 'Комната',
    nav3: 'Награда',
    rule: 'Правила',
    share: 'Поделиться',
    rulePop:
      '1. Все турецкие пользователи могут участвовать;<br/>2. Каждый раз, когда вы дарите подарки мероприятия, вы получаете соответствующую валюту события;<br/>3. В течение мероприятия вы автоматически попадете в рейтинг в зависимости от количества подарков, а три лучших участника получат эксклюзивные головные уборы, автомобили и VIP-награды.<br/>4. Соревнование закончится 8 сентября 2024 года в 23:59 по саудовскому времени;<br/>5. Окончательное право интерпретации этого события принадлежит Yayya, и это событие не связано с Apple.',
    world: 'Мир',
    country: 'KSA',
    notice: 'Если в течение мероприятия страна вашей учетной записи изменится, ваш рейтинг трофеев будет сброшен.',
    days: 'дней',
    eventGift: 'Подарок мероприятия',
    day: 'День',
    hour: 'Час',
    min: 'Мин',
    sec: 'Сек'
  },
  fa: {
    copyright: 'حق تفسیر نهایی این رویداد متعلق به Yayya است و این رویداد هیچ ارتباطی با اپل ندارد.',
    timeR: 'شمارش معکوس',
    timeR2: ' قبل از شروع رویداد',
    rank: 'رتبه‌بندی',
    toptitle: 'Zafer Bayramı',
    title: 'جشن KSA',
    ruleDes:
      'برای گرامیداشت روز ملی KSA، ما از ۲۳ تا ۳۰ سپتامبر رویدادهایی برگزار خواهیم کرد. در طول رویداد، کاربران هدایای زیر را ارسال می‌کنند و برنده می‌تواند جوایز دریافت کند.',
    nav1: 'رتبه‌بندی',
    nav2: 'اتاق',
    nav3: 'پاداش',
    rule: 'قوانین',
    share: 'اشتراک‌گذاری',
    rulePop:
      '1. همه کاربران ترکیه‌ای می‌توانند شرکت کنند؛<br/>2. هر بار که هدیه رویداد را ارسال کنید، ارز معادل آن را دریافت خواهید کرد؛<br/>3. در طول رویداد، بر اساس تعداد هدایای ارسال‌شده به صورت خودکار وارد جدول رتبه‌بندی خواهید شد و سه نفر برتر جوایز ویژه شامل کلاه، خودرو و جوایز VIP دریافت خواهند کرد.<br/>4. این رقابت در ساعت ۲۳:۵۹ به وقت عربستان سعودی در تاریخ ۸ سپتامبر ۲۰۲۴ به پایان خواهد رسید.<br/>5. حق تفسیر نهایی این رویداد متعلق به Yayya است و این رویداد هیچ ارتباطی با اپل ندارد.',
    world: 'جهان',
    country: 'KSA',
    notice: 'اگر کشور حساب شما در طول رویداد تغییر کند، رتبه‌بندی جام شما پاک خواهد شد.',
    days: 'روزها',
    eventGift: 'هدیه رویداد',
    day: 'روز',
    hour: 'ساعت',
    min: 'دقیقه',
    sec: 'ثانیه'
  },
  ur: {
    copyright: 'اس ایونٹ کی حتمی تشریح کا حق Yayya کے پاس ہے، اور اس ایونٹ کا ایپل سے کوئی تعلق نہیں ہے۔',
    timeR: 'گنتی شروع ہو رہی ہے',
    timeR2: 'سرگرمی شروع ہونے سے پہلے',
    rank: 'درجہ بندی',
    toptitle: 'یوم فتح',
    title: 'سعودی عرب کا جشن',
    ruleDes:
      'سعودی عرب کے یوم قومی کے موقع پر، ہم 23 سے 30 ستمبر تک تقریبات منعقد کریں گے۔ ایونٹ کے دوران، صارفین درج ذیل تحائف بھیجیں گے، اور فاتح انعامات حاصل کر سکتا ہے۔',
    nav1: 'درجہ بندی',
    nav2: 'روم',
    nav3: 'انعام',
    rule: 'قواعد',
    share: 'اشتراک کریں',
    rulePop:
      '1. تمام ترکی کے صارفین حصہ لے سکتے ہیں؛<br/>2. ہر بار جب آپ ایونٹ گفٹ دیں گے، آپ کو متعلقہ ایونٹ گفٹ کرنسی ملے گی؛<br/>3. ایونٹ کے دوران، آپ تحائف کی تعداد کے مطابق خود بخود لیڈر بورڈ میں شامل ہو جائیں گے، اور ٹاپ تین کو ایونٹ کے خصوصی ہیڈ ویئر، گاڑیاں، اور VIP انعامات ملیں گے۔<br/>4. مقابلہ 8 ستمبر 2024 کو سعودی وقت کے مطابق 23:59 پر ختم ہوگا؛<br/>5. اس ایونٹ کی حتمی تشریح کا حق Yayya کے پاس ہے، اور اس ایونٹ کا ایپل سے کوئی تعلق نہیں ہے۔',
    world: 'دنیا',
    country: 'سعودی عرب',
    notice: 'اگر سرگرمی کے دوران آپ کے اکاؤنٹ کا ملک تبدیل ہوتا ہے، تو آپ کی ٹرافی درجہ بندی صاف ہو جائے گی۔',
    days: 'دن',
    eventGift: 'ایونٹ گفٹ',
    day: 'دن',
    hour: 'گھنٹہ',
    min: 'منٹ',
    sec: 'سیکنڈ'
  }
}



// WEBPACK FOOTER //
// src/pages/app/game-baisun/lang.js